import get from 'lodash/get';
import { trackPage } from '../utils/analytics/analyticsManager';

const publishAnalytics = (data, dataKey, props) => {
    const virtualPath = '/vp/publish';
    if (!props.isEdit) {
        switch (dataKey) {
            case 'fields': {
                const sections = {
                    ad: ['section', 'search_option', 'property_type'],
                    address: ['address.isFull'],
                    propertyDetails: ['rooms', 'area.base',
                        'floor.on_the', 'floor.out_of', 'groundFloor', 'hasBasement',
                        'parking.aboveground', 'parking.underground', 'balconies',
                        'light_direction.east', 'light_direction.north',
                        'light_direction.south', 'light_direction.west',
                        'bathrooms', 'toilets', 'payments.tax'
                    ],
                    buildingDetails: ['construction_year',
                        'elevators', 'payments.maintenance'
                    ],
                    commodities: ['commodities'],
                    imagesVideos: ['images', 'videos'],
                    priceDetails: ['price', 'entry_date.date']
                };
                for (const sectionKey in sections) {
                    if ({}.hasOwnProperty.call(sections, sectionKey)) {
                        for (const elementKey of sections[sectionKey]) {
                            const elementValue = get(data, elementKey);
                            if (elementValue !== undefined && elementValue !== null &&
                                elementValue !== get(props.fields, elementKey)) {
                                switch (sectionKey) {
                                    case 'ad':
                                    case 'address':
                                    case 'propertyDetails': {
                                        trackPage(`${virtualPath}/${sectionKey}/${elementKey}/${elementValue}`);
                                        return;
                                    }
                                    case 'commodities': {
                                        trackPage(`${virtualPath}/${sectionKey}/${elementValue}`);
                                        return;
                                    }
                                    case 'imagesVideos': {
                                        if (elementValue.length > 0) {
                                            trackPage(`${virtualPath}/${sectionKey}/
                                            ${elementKey}/${elementValue.length}`);
                                        }
                                        return;
                                    }
                                    default: {
                                        trackPage(`${virtualPath}/${sectionKey}/${elementKey}`);
                                        return;
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            }
            case 'userAuthentication': {
                const elementValue = get(data, 'userIsAuthorized');
                if (elementValue !== undefined && elementValue !== null &&
                    elementValue !== get(props.userAuthentication, 'userIsAuthorized')) {
                        trackPage(`${virtualPath}/${dataKey}/${elementValue}`);
                    }
                break;
            }
            case 'package': {
                let route = `${virtualPath}/${dataKey}`;
                if (data.checked !== undefined && data.checked !== null) {
                    route += `/type/${data.checked}`;
                }
                if (data.period !== undefined && data.period !== null) {
                    route += `/period/${data.period}`;
                }
                trackPage(route);
                break;
            }
            default: {
                trackPage(`${virtualPath}/${dataKey}/${data}`);
                break;
            }
        }
    }
};

export default publishAnalytics;
